export default __webpack_public_path__ + "static/media/pricelocq-logo.7c59ffd5.png";